// extracted by mini-css-extract-plugin
export default {"forgotPassword":"LoginForm_forgotPassword__xYkuJ","newUser":"LoginForm_newUser__zWcKx","submitGroup":"LoginForm_submitGroup__RsxR0"};